import React, { useEffect, useRef, useState } from 'react';
import type { Graph, Node } from '@antv/x6';
import NodeContextMenu from './NodeContextMenu';

interface NodeMenuTriggerProps {
  node: Node;
  graph: Graph;
}

const NodeMenuTrigger: React.FC<NodeMenuTriggerProps> = ({ node, graph }) => {
  const [pos, setPos] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const update = () => {
      const bbox = node.getBBox();
      const pt = graph.localToClient(bbox.x + bbox.width, bbox.y);
      setPos({ x: pt.x, y: pt.y });
    };
    update();

    const handleChange = () => update();
    node.on('change:position', handleChange);
    node.on('change:size', handleChange);
    graph.on('scale', handleChange);
    graph.on('translate', handleChange);

    return () => {
      node.off('change:position', handleChange);
      node.off('change:size', handleChange);
      graph.off('scale', handleChange);
      graph.off('translate', handleChange);
    };
  }, [node, graph]);

  return (
    <>
      <button
        ref={anchorRef}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
        onMouseDown={(e) => e.stopPropagation()}
        title="节点菜单"
        style={{
          position: 'fixed',
          left: pos.x - 10,
          top: pos.y - 10,
          width: 20,
          height: 20,
          zIndex: 100,
          borderRadius: '50%',
          border: '1px solid #e0e0e0',
          background: '#fff',
          color: '#595959',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
          fontSize: 12,
          lineHeight: 1,
          padding: 0,
        }}
      >
        ⋯
      </button>
      <NodeContextMenu
        node={node}
        nodeType={node.getData()?.type || 'object'}
        open={open}
        onOpenChange={setOpen}
        anchor={anchorRef.current}
      />
    </>
  );
};

export default NodeMenuTrigger;
